/* Gallo PDP - keep the page honest about what the customer has selected.

   Two things were out of step with the option controls:

   1. The gallery rendered every photograph on the product. The metal swatches
      filtered it; the shape control never did, so a ring offered in seven
      centre-stone shapes showed all seven at once and the shape control changed
      nothing on the page. The old site still behaves that way.

   2. The line under the title comes from a product-level metafield, so it read
      0.25ct round while the customer was looking at an Emerald.

   Gallo's photographs carry their own labels (alt=14k Yellow Gold Marquise),
   which the section writes onto each cell as data-alt. This reads both option
   controls, keeps the cells whose label matches, and corrects the shape word in
   the subtitle. It only hides, shows and re-words; no product, photograph or
   variant is touched.

   Not every shape a setting can hold has been photographed. The Petite U Prong
   is sold in seven and shot in four; there is no Radiant or Princess cut
   photography anywhere in the store, on any setting. When the chosen shape has
   no pictures the honest thing is not to fall back to the whole gallery - that
   puts four different centre stones on screen at once and tells the customer
   nothing. Instead it shows ONE shape, consistently, in the metal that was
   chosen, and says plainly underneath that the stone in the photograph is not
   the one selected. A wrong picture with a caption beats four wrong pictures
   without one, and neither is a substitute for shooting the missing shapes.

   The carat figure is left exactly as the metafield gives it - there is no
   per-shape carat in the data, so inventing one here would be worse than
   leaving it alone. */
(function () {
  'use strict';

  var METALS = ['white', 'yellow', 'rose', 'platinum'];
  var SHAPES = ['round', 'radiant', 'marquise', 'emerald', 'princess', 'cushion',
                'pear', 'oval', 'asscher', 'heart', 'trillion', 'baguette'];

  /* Which shape to stand in with when the chosen one was never shot. Round
     first because it is the reference cut and the one buyers picture by
     default; the rest in descending order of how ordinary they look. */
  var STAND_IN = ['round', 'oval', 'cushion', 'emerald', 'marquise', 'pear',
                  'princess', 'radiant', 'asscher', 'heart'];

  function norm(v) { return String(v == null ? '' : v).toLowerCase().replace(/\s+/g, ' ').trim(); }
  function wordIn(list, text) {
    var t = norm(text);
    for (var i = 0; i < list.length; i += 1) { if (t.indexOf(list[i]) !== -1) return list[i]; }
    return null;
  }
  function titleCase(w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }

  /* The chosen metal comes from the swatch row, the shape from whichever option
     control actually offers shapes - never from the concierge widget's own
     dropdowns, which sit on the same page. */
  function currentSelection() {
    var swatch = document.querySelector('[data-variant-metal-group] .metal-swatch.selected, [data-metal-group] .metal-swatch.selected');
    var metal = swatch ? wordIn(METALS, swatch.getAttribute('data-opt-value') || swatch.getAttribute('data-metal-name')) : null;

    var shape = null;
    var selects = document.querySelectorAll('#pdp-form .variant-opt-select, #pdp-form select');
    for (var i = 0; i < selects.length; i += 1) {
      var s = selects[i];
      var offersShapes = false;
      for (var j = 0; j < s.options.length; j += 1) {
        if (wordIn(SHAPES, s.options[j].value)) { offersShapes = true; break; }
      }
      if (offersShapes) { shape = wordIn(SHAPES, s.value); break; }
    }
    return { metal: metal, shape: shape };
  }

  function matching(cells, sel, useShape) {
    return cells.filter(function (cell) {
      var label = cell.getAttribute('data-alt') || '';
      var metal = wordIn(METALS, label);
      var shape = wordIn(SHAPES, label);
      if (!metal && !shape) return true;
      if (sel.metal && metal && metal !== sel.metal) return false;
      if (useShape && sel.shape && shape && shape !== sel.shape) return false;
      return true;
    });
  }

  function groupByShape(cells) {
    var out = {};
    cells.forEach(function (c) {
      var s = wordIn(SHAPES, c.getAttribute('data-alt') || '') || '';
      if (!s) return;
      if (!out[s]) out[s] = [];
      out[s].push(c);
    });
    return out;
  }

  /* The note lives INSIDE the gallery grid and spans its columns. Putting it
     beside the gallery would make it a third item in the two-column product
     layout and shove the buy panel down the page. */
  function setNote(gallery, text) {
    var el = gallery.querySelector('[data-gallery-note]');
    if (!text) { if (el) el.parentNode.removeChild(el); return; }
    if (!el) {
      el = document.createElement('p');
      el.className = 'gallery-note';
      el.setAttribute('data-gallery-note', '');
      gallery.appendChild(el);
    }
    gallery.appendChild(el);
    el.textContent = text;
  }

  function filterGallery(sel) {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var cells = Array.prototype.slice.call(gallery.querySelectorAll('.gallery-cell'));
    if (cells.length < 2) return;

    var basis = 'metal + shape';
    var note = '';
    var keep = matching(cells, sel, true);

    if (!keep.length && sel.shape) {
      var pool = groupByShape(matching(cells, sel, false));
      var pick = null;
      for (var i = 0; i < STAND_IN.length; i += 1) {
        if (pool[STAND_IN[i]] && pool[STAND_IN[i]].length) { pick = STAND_IN[i]; break; }
      }
      if (!pick) { var ks = Object.keys(pool); pick = ks.length ? ks[0] : null; }
      if (pick) {
        keep = pool[pick];
        basis = 'stand-in: ' + pick;
        note = 'This setting has not been photographed with a ' + titleCase(sel.shape)
             + ' centre stone. The photographs above show it with a ' + titleCase(pick)
             + '; the ring and the metal are the ones you have selected.';
      }
    }

    if (!keep.length) { keep = cells; basis = 'no match - showing all'; }

    cells.forEach(function (cell) {
      cell.style.display = keep.indexOf(cell) > -1 ? '' : 'none';
      cell.classList.remove('span2');
    });
    keep[0].classList.add('span2');
    setNote(gallery, note);
    gallery.setAttribute('data-gallery-showing',
      keep.length + ' of ' + cells.length + ' - ' + (sel.metal || 'any metal') + ' / ' + (sel.shape || 'any shape') + ' - ' + basis);
  }

  /* The subtitle sits directly under the product title. Its original wording is
     kept so the shape word can be swapped without the sentence drifting after
     repeated changes. */
  function updateSubtitle(sel) {
    if (!sel.shape) return;
    var h1 = document.querySelector('.pdp-config h1');
    if (!h1) return;
    var sub = h1.nextElementSibling;
    if (!sub || sub.tagName !== 'P') return;

    if (!sub.hasAttribute('data-sub-original')) sub.setAttribute('data-sub-original', sub.textContent);
    var original = sub.getAttribute('data-sub-original') || '';
    var was = wordIn(SHAPES, original);
    if (!was) return;
    if (was === sel.shape) { sub.textContent = original; return; }

    var re = new RegExp('\\b' + was + '\\b', 'i');
    sub.textContent = original.replace(re, titleCase(sel.shape));
  }

  function apply() {
    var sel = currentSelection();
    if (!sel.metal && !sel.shape) return;
    filterGallery(sel);
    updateSubtitle(sel);
  }

  var pending = null;
  function schedule() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () { try { apply(); } catch (e) { /* never break the page */ } }, 40);
  }

  function init() {
    if (!document.querySelector('[data-gallery]')) return;

    document.addEventListener('click', function (e) {
      var node = e.target;
      if (!node || typeof node.closest !== 'function') return;
      if (node.closest('.metal-swatch')) schedule();
    }, true);

    document.addEventListener('change', function (e) {
      var node = e.target;
      if (!node || typeof node.closest !== 'function') return;
      if (node.closest('#pdp-form')) schedule();
    }, true);

    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
